export default __webpack_public_path__ + "static/media/wall-candle.ccda14db.png";